import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '@material-ui/core';
import { Edit, Delete } from '@material-ui/icons';

import { DotActions } from '@modules/layout/moleculas';

type LapAccessActionsProps = {
    onEdit: () => void;
    onRemove: () => void;
    disableEdit?: boolean;
    disableRemove?: boolean;
};

const editIcon = <Edit style={{ fontSize: 16 }} />;
const removeIcon = <Delete style={{ fontSize: 16 }} />;

const LapAccessActions = (props: LapAccessActionsProps): React.ReactElement | null => {
    const { disableEdit, disableRemove, onEdit, onRemove } = props;

    const { t } = useTranslation(['access']);

    if (disableEdit && disableRemove) {
        return null;
    }

    return (
        <DotActions>
            {dotActionsProps => {
                const { onClick: dotActionsOnClick } = dotActionsProps;

                return (
                    <>
                        {disableEdit ? null : (
                            <MenuItem onClick={dotActionsOnClick(onEdit)}>
                                <span>{editIcon}</span>
                                <span>{t('access:actions.edit_access')}</span>
                            </MenuItem>
                        )}

                        {disableRemove ? null : (
                            <MenuItem onClick={dotActionsOnClick(onRemove)}>
                                <span>{removeIcon}</span>
                                <span>{t('access:actions.remove_access')}</span>
                            </MenuItem>
                        )}
                    </>
                );
            }}
        </DotActions>
    );
};

export { LapAccessActions };
